import setBillingAddress from './setBillingAddress';

export default setBillingAddress;
